var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _vm.isUpToDate
      ? _c(
          "div",
          [
            _c("b-loading", {
              attrs: { "is-full-page": true, active: _vm.isLoading },
              on: {
                "update:active": function($event) {
                  _vm.isLoading = $event
                }
              }
            }),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                attrs: { active: _vm.activeModal, canCancel: [] },
                on: {
                  "update:active": function($event) {
                    _vm.activeModal = $event
                  }
                }
              },
              [_c("selectStore", { attrs: { cancelBtn: false } })],
              1
            ),
            _vm._v(" "),
            _c("main", [_c("router-view")], 1)
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 349
// module chunks = 1